<div class="chart-container" [style.height]="height">
  <p-chart type="bar" [data]="data" [options]="options"></p-chart>
</div>
<ul class="legend">
  <li *ngFor="let legendItem of legendItems" class="legend-item">
    <span
      class="legend-color"
      [style]="{ 'background-color': legendItem.color }"
    ></span>
    {{ legendItem.label }}
  </li>
</ul>
